module.exports = __webpack_public_path__ + "img/bot_row.82ea39.png";